import { useEffect, useState } from 'react';
import { organizationService } from '../services/organization.service';

const ORG_OPTIONS_CHANGED_EVENT = 'org-options-changed';

/** Call after branch/department CRUD so pickers refetch without a full page reload. */
export function invalidateOrganizationOptions(): void {
  window.dispatchEvent(new Event(ORG_OPTIONS_CHANGED_EVENT));
}

function useOrgOptionsRefreshToken(): number {
  const [refreshToken, setRefreshToken] = useState(0);

  useEffect(() => {
    const onInvalidate = () => setRefreshToken((t) => t + 1);
    window.addEventListener(ORG_OPTIONS_CHANGED_EVENT, onInvalidate);
    return () => window.removeEventListener(ORG_OPTIONS_CHANGED_EVENT, onInvalidate);
  }, []);

  return refreshToken;
}

/** Branch names for pickers — loaded from the API (master branches table). */
export function useBranchOptions(): string[] {
  const refreshToken = useOrgOptionsRefreshToken();
  const [options, setOptions] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;
    organizationService
      .getPickerBranches()
      .then((list) => {
        if (!cancelled) setOptions(list);
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      });
    return () => {
      cancelled = true;
    };
  }, [refreshToken]);

  return options;
}

/** Department names for pickers — loaded from the API (master departments table). */
export function useDepartmentOptions(branch?: string): string[] {
  const refreshToken = useOrgOptionsRefreshToken();
  const [options, setOptions] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;
    organizationService
      .getPickerDepartments(branch)
      .then((list) => {
        if (!cancelled) setOptions(list);
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      });
    return () => {
      cancelled = true;
    };
  }, [branch, refreshToken]);

  return options;
}
